import React from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import SectionHeading from "./SectionHeading";

const CasesSection = () => {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const t = content[lang].cases;

  return (
    <section id="casos" className="relative py-24 md:py-28 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeading kicker={t.kicker} title={t.title} />
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {t.items.map((c) => {
            const clickable = Boolean(c.slug);
            return (
              <div
                key={c.name}
                onClick={clickable ? () => navigate(`/casos/${c.slug}`) : undefined}
                role={clickable ? "button" : undefined}
                tabIndex={clickable ? 0 : undefined}
                onKeyDown={clickable ? (e) => { if (e.key === "Enter") navigate(`/casos/${c.slug}`); } : undefined}
                data-testid={`case-card-${c.slug || c.name.toLowerCase()}`}
                className={`group flex flex-col rounded-2xl border bg-narwhal-panel/50 p-6 transition-colors duration-300 ${clickable ? "cursor-pointer border-narwhal-teal/30 hover:border-narwhal-teal/60" : "border-white/8 hover:border-narwhal-teal/35"}`}
              >
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-white">{c.name}</h3>
                    <span className="text-xs text-narwhal-muted">{c.sector}</span>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-narwhal-teal transition-colors" />
                </div>

                <div className="mt-5 space-y-3 text-sm">
                  <div>
                    <span className="text-[11px] font-semibold tracking-wide uppercase text-narwhal-teal/70">{t.desafioLabel}</span>
                    <p className="mt-0.5 text-narwhal-muted">{c.desafio}</p>
                  </div>
                  <div>
                    <span className="text-[11px] font-semibold tracking-wide uppercase text-narwhal-teal/70">{t.sistemaLabel}</span>
                    <p className="mt-0.5 text-narwhal-muted">{c.sistema}</p>
                  </div>
                </div>

                <div className="mt-5 pt-5 border-t border-white/8">
                  <div className="text-2xl font-semibold text-narwhal-teal">{c.metric}</div>
                  <div className="text-xs text-narwhal-muted">{c.metricLabel}</div>
                </div>

                {clickable && (
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-narwhal-teal" data-testid={`case-card-link-${c.slug}`}>
                    {t.caseCta}<ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CasesSection;
